import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/all';

const StyledHeader = styled.h2`
  text-align: left;
  color: ${({ theme }) => theme.color.first};
  font-size: ${({ theme }) => theme.font.size.s};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-family: Raleway, sans-serif;
  line-height: 32px;
  margin: 50px 40px 20px;
  position: relative;
  &::before {
    content: '';
    width: 80px;
    height: 5px;
    background-color: ${({ theme }) => theme.color.fourth};
    position: absolute;
    top: 32px;
    left: 0;
  }
  ${({ theme }) => theme.mq.tablet} {
    font-size: ${({ theme }) => theme.font.size.sm};
    line-height: 50px;
    margin: 50px 50px 20px;
    &::before {
      width: 100px;
      top: 50px;
    }
  }
  ${({ theme }) => theme.mq.desktop} {
    font-size: ${({ theme }) => theme.font.size.m};
    line-height: 75px;
    &::before {
      width: 140px;
      top: 75px;
    }
  }
  ${({ theme }) => theme.mq.big} {
    font-size: ${({ theme }) => theme.font.size.ml};
    margin: 50px 80px 40px;
    &::before {
      width: 200px;
    }
  }
`;

const HeaderSection = ({ children }) => {
  let header = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.from(header, 1, {
      scrollTrigger: header,
      opacity: 0,
      y: 50,
    });
  }, []);

  return (
    <StyledHeader
      ref={el => {
        header = el;
      }}
    >
      {children}
    </StyledHeader>
  );
};

HeaderSection.propTypes = {
  children: PropTypes.string.isRequired,
};

export default HeaderSection;
